import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP } from "./data";

const FLOAT_INITIAL = { opacity: 0, scale: 0 };
const FLOAT_ANIMATE = { opacity: 1, scale: 1 };
const FLOAT_TRANSITION = { delay: 1.2, type: "spring", stiffness: 260, damping: 18 };
const FLOAT_HOVER = { scale: 1.1 };

export const WhatsAppFloat = () => (
  <motion.a
    href={WHATSAPP}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="Chat on WhatsApp"
    initial={FLOAT_INITIAL}
    animate={FLOAT_ANIMATE}
    transition={FLOAT_TRANSITION}
    whileHover={FLOAT_HOVER}
    className="fixed bottom-6 left-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)]"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" />
    <MessageCircle size={26} className="relative" />
  </motion.a>
);
